import React, { useState, useEffect } from 'react';
import { auth } from '../firebaseConfig';
import { onAuthStateChanged } from 'firebase/auth';
import AdminImageManagement from './AdminImageManagement';
import AdminServiceManagement from './AdminServiceManagement';

const AdminEventSpaces = () => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (currentUser) => {
      setUser(currentUser);
      setLoading(false);
    });
    return () => unsubscribe();
  }, []);

  if (loading) {
    return <p>Cargando...</p>;
  }

  if (!user) {
    return <p>Debe iniciar sesión para gestionar los espacios de eventos.</p>;
  }

  return (
    <div style={{ padding: '20px' }}>
      <h1>Admin Event Spaces</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}

      <AdminImageManagement user={user} setError={setError} />
      <AdminServiceManagement user={user} setError={setError} />
    </div>
  );
};

export default AdminEventSpaces;

